<template>
  <el-form-item class="wrapper-upload" :label="label" label-position="right" v-bind="$attrs">
    <div class="a-upload__content">
      <el-upload :on-change="handlePreview"
                 :on-remove="handleRemove"
                 action=""
                 ref="aUpload"
                 :show-file-list="showFileList"
                 :limit="limit"
                 :auto-upload="false">
        <div class="g-upload__content">
          <div class="preview-subarea">
            <el-button class="flex flex-row items-center" type="secondary" :loading="loading">
              <slot name="buttonText">
                {{$t('components.upload.clickToUpload')}}
              </slot>
            </el-button>
            <div slot="tip" class="el-upload__tip">
              <slot name="hint">
                {{$t('components.upload.hint')}}
              </slot>
            </div>
          </div>
        </div>
      </el-upload>

      <div class="img-preview" v-if="showPreview">
        <slot name="img-preview">
          <a :src="value"></a>
          <el-button v-if="value"
                     class="img-preview__delete-icon"
                     type="danger"
                     icon="el-icon-delete"
                     circle
                     @click.stop="handleRemove"/>
        </slot>
      </div>
    </div>
  </el-form-item>

</template>

<script>
  import { Notification } from 'element-ui'
  import includes from 'lodash/includes'
  import { uploadApplyFile } from '../../API/file'

  export default {
    name: 'upload',
    inheritAttrs: false,
    props: {
      value: {
        type: String,
        default: ''
      },
      label: String,
      allowedFiles: {
        type: Array,
        default: () => [{
          name: 'PDF',
          type: 'application/pdf',
          extension: '.pdf'
        }, {
          name: 'DOC',
          type: 'application/msword',
          extension: '.doc'
        }, {
          name: 'DOCX',
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          extension: '.docx'
        }, {
          name: 'LATEX',
          type: 'application/x-latex',
          extension: '.ltx'
        }]
      },
      maxSizeMb: {
        type: Number,
        default: 2
      },
      uploadParams: {
        type: Object,
        default: () => ({})
      },
      limit: {
        type: Number,
        default: 1
      },
      showFileList: {
        type: Boolean,
        default: true
      },
      showPreview: Boolean,
      hideUploadSuccessMessage: Boolean
    },
    data() {
      return {
        maxFileSizeMb: 1.4,
        loading: false,
      }
    },
    computed: {
      fileTypes() {
        return this.allowedFiles.map(f => f.type)
      },
      typeNames() {
        return this.allowedFiles.map(f => f.name).join(', ')
      }
    },
    methods: {
      beforeAvatarUpload(file) {
        const isAllowedFormat = includes(this.fileTypes, file.raw.type)
        const isAllowedSize = file.size / 1024 / 1024 < this.maxSizeMb
        if (!isAllowedFormat) {
          Notification.error({ message: 'File format error', dangerouslyUseHTMLString: true })
        } else if (!isAllowedSize) {
          Notification.error({ message: 'Size error', dangerouslyUseHTMLString: true })
        }
        return isAllowedFormat && isAllowedSize
      },
      async handlePreview(file) {
        if (!this.beforeAvatarUpload(file)) {
          this.$refs.aUpload.clearFiles()
          return
        }
        try {
          this.loading = true
          const localSrc = await uploadApplyFile(file, this.uploadParams)
          if (!this.hideUploadSuccessMessage) {
            Notification.success({ message: 'File upload success' })
          }
          this.$emit('input', localSrc)
        } catch (e) {
          if (!e.handled) {
            Notification.error({ message: 'File upload error', dangerouslyUseHTMLString: true })
          }
          this.$refs.aUpload.clearFiles()
        } finally {
          this.loading = false
        }
      },
      handleRemove() {
        this.$emit('input', null)
      },
      reset() {
        this.$refs.aUpload.clearFiles()
      },
    }
  }
</script>

<style lang="scss">
  .wrapper-upload {
    .preview-subarea {
      text-align: center;
    }

    .el-upload-list {
      .el-upload-list__item {
        .el-icon-close-tip {
          margin-right: 20px;
        }
      }
    }

    .el-upload {
      display: block;
      text-align: initial;
      clear: both;
      margin-top: 15px;
    }

    .a-button {
      font-size: 12px;
    }

    .el-upload__tip {
      font-size: 10px;
      line-height: 1.4;
      text-align: left;
    }

    .img-preview {
      margin-top: 15px;
      text-align: left;
      position: relative;

      img {
        max-width: 200px;
        min-width: 200px;
      }

      &:hover {
        .img-preview__delete-icon {
          display: block;
        }
      }
    }

    .img-preview__delete-icon {
      position: absolute;
      right: 190px;
      top: 4px;
      display: none;
    }
  }

</style>
